// *******************************************************
// Background Export File
// -------------------------------------------------------
// All Backgrounds Across the Application
// -------------------------------------------

// *******************************************
// Exports
// -------------------------------------------
import * as Garden_ from './Garden';
// --------------------------------

// *******************************************
// Exports
// -------------------------------------------
export {default as Home} from './Home';
export {default as Intro} from './Intro';
export {default as Market} from './Market';
export {default as Kitchen} from './Kitchen';
export {default as Result} from './Result';
export {default as Score} from './Score';
export const Garden = Garden_;
// --------------------------------



// WEBPACK FOOTER //
// ./src/components/Background/index.js